module.exports = __webpack_public_path__ + "static/media/playertable icon-1.f389c977.svg";